import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=34f8f03a&scoped=true&"
import script from "./Poll.vue?vue&type=script&lang=js&"
export * from "./Poll.vue?vue&type=script&lang=js&"
import style0 from "./Poll.vue?vue&type=style&index=0&id=34f8f03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8f03a",
  null
  
)

export default component.exports